import * as React from 'react';
import Box from '@mui/material/Box';
import { InputCPF } from "../../../../../components/storybook";
import { grayColor } from 'assets/jss/material-dashboard-pro-react.jsx';

export function MuiTextFieldCPF({ cpf, setCpf, themeColor, error, helperText }) {
  const defaultColor = themeColor?.navigation?.buttons?.backgroundColor || '#000000'

  return (
    <Box
      sx={{
        width: '100%',
        '& label.Mui-focused': {
          color: grayColor[2],
        },
        '& label': {
          fontSize: '14px',
          lineHeight: 1.2,
          zIndex: 0,
          color: '#5D5D5D',
          fontWeight: 400
        },
        '& fieldset': {
          borderColor: 'hsl(0,0%,85%)'
        },
        '& .MuiFormLabel-root.Mui-disabled': {
          transform: 'translate(14px, -14px) scale(0.75)',
        },

        '& .MuiOutlinedInput-root': {
          color: "#838383",
          fontFamily: "roboto",
          fontWeight: 400,

        },
        '& .MuiOutlinedInput-root.Mui-disabled': {
          backgroundColor: 'hsl(0,0%,95%)',
          zIndex: -1,
          '& fieldset': {
            borderColor: 'hsl(0,0%,95%)'
          }
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
          font: 'normal normal normal 12px Segoe UI',
          position: 'absolute',
          marginLeft: '0px',
          color: '#5D5D5D',
          marginBottom: '5px',
          transform: 'translate(-1px, -18px)',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#b2b2b2',
            borderBottomColor: '#b2b2b2',
          },
          '&:hover fieldset': {
            borderColor: 'hsl(0,0%,80%)',
          },
          '& legend': {
            width: '0px',
          },
        },
      }}
    >
      <InputCPF
        type="text"
        fullWidth
        value={cpf}
        onChange={(e) => setCpf(e.target.value)}
        variant="outlined"
        label={cpf && "CPF"}
        placeholder="CPF"
        size="small"
        defaultColor={defaultColor}
        error={error}
        helperText={helperText}
      />
    </Box>
  );
}
